<template>
  <div>
    <vx-card>
      <ListTiposAtendimento :subjectPermission="subjectPermission"></ListTiposAtendimento>
    </vx-card>
  </div>
</template>

<script>
import ListTiposAtendimento from "./../../lists/ListTipoAtendimento";

export default {
  data() {
    return {
      subjectPermission: "Tipo de Atendimento",
    };
  },
  methods: {},
  components: {
    ListTiposAtendimento,
  },
};
</script>
